import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {TIMEZONE} from "./LS-CONSTANT";

dayjs.extend(utc);
dayjs.extend(timezone);

const USER_TIMEZONE = TIMEZONE;

/**
 * Formats a UTC ISO string to "DD MMM YYYY, hh:mm A" in the user's local timezone.
 * @param {string|null} iso - UTC ISO string e.g. "2026-05-06T08:34:00Z"
 * @returns {string} e.g. "06 May 2026, 02:04 PM" or "-" if null/invalid
 */
export const formatDateTime = (iso) => {
    if (!iso) return '-';
    try {
        return dayjs(iso).tz(USER_TIMEZONE).format('DD MMM YYYY, hh:mm A');
    } catch {
        return '-';
    }
};